export const endpoints = {
  LOGIN: '/api/v1/auth:login',
  LOGOUT: '/api/v1/auth:logout',
  TWO_FACTOR_LOGIN: '/api/v1/auth:2-factor-login',
  TWO_FACTOR_GENERATE: '/api/v1/auth:2-factor-generate',
  TWO_FACTOR_ENABLE: '/api/v1/auth:2-factor-enable',
  TWO_FACTOR_DISABLE: '/api/v1/auth:2-factor-disable',
};
